"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmLoading = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
exports.SmLoading = (0, react_1.forwardRef)((_a, ref) => {
    var { type = 'primary', loadingVariant = 'brand', loadingSize = 'large', className } = _a, props = __rest(_a, ["type", "loadingVariant", "loadingSize", "className"]);
    const loadingClassName = (0, classnames_1.default)('c-loading', `-${type}`, `-${type === 'tertiary' ? loadingVariant : loadingSize}`, className);
    return (react_1.default.createElement("div", Object.assign({}, props, { ref: ref, className: loadingClassName, role: "status" }),
        type === 'secondary' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: "c-loading__content" }),
            react_1.default.createElement("span", { className: "c-loading__content" }),
            react_1.default.createElement("span", { className: "c-loading__content" }))),
        type === 'tertiary' && (react_1.default.createElement("svg", { className: "c-loading__content", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("circle", { cx: "16", cy: "16", r: "15" }),
            react_1.default.createElement("path", { d: "M16 1C17.9698 1 19.9204 1.38799 21.7403 2.14181C23.5601 2.89563 25.2137\n              4.00052 26.6066 5.3934C27.9995 6.78628 29.1044 8.43987 29.8582\n              10.2598C30.612 12.0796 31 14.0302 31 16C31 17.9698 30.612 19.9204 29.8582\n              21.7403C29.1044 23.5601 27.9995 25.2137 26.6066 26.6066C25.2137 27.9995\n              23.5601 29.1044 21.7402 29.8582C19.9204 30.612 17.9698 31 16 31C14.0302 31\n              12.0796 30.612 10.2597 29.8582C8.43986 29.1044 6.78627 27.9995 5.39339\n              26.6066C4.00052 25.2137 2.89562 23.5601 2.1418 21.7402C1.38798 19.9204\n              0.999999 17.9698 1 16C1 14.0302 1.38799 12.0796 2.14181 10.2597C2.89563\n              8.43986 4.00052 6.78627 5.3934 5.39339C6.78628 4.00051 8.43987 2.89562\n              10.2598 2.1418C12.0796 1.38798 14.0302 0.999999 16 1L16 1Z", strokeLinecap: "round" })))));
});
//# sourceMappingURL=index.js.map